module.exports = __webpack_public_path__ + "img/hr-rock-huge-20.20afa2f7.png";